import type { ICongrupoRepository } from '@domain/repositories/ICongrupoRepository';
import type { Congrupo } from '@domain/entities/congrupo';

export class GetCongrupoUseCase {
  constructor(
    private readonly congrupoRepository: ICongrupoRepository
  ) {}

  async execute(
    table: string,
    group: string
  ): Promise<Congrupo[]> {
    return this.congrupoRepository.findGroup(table, group);
  }
}